import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Container } from 'reactstrap';
import BreadCrumb from 'Components/Common/BreadCrumb';
import styles from 'pages/Products/styles/products.module.css';
import 'styles/common/checked-input-style.css';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  setProductsCategoryOptions,
  setSupplierOptions,
  setModalOpen,
  setActiveInputIndex,
  setIsEdit,
  resetProduct,
  setModalBackdrop,
  setProductEditFormDetails,
  setImgDisplay,
  setSelectedFiles,
  setIsPieces,
  setIsNoFragment,
  setIsNoStock,
  apiError,
  apiSuccess,
  setEditStoreId,
  setProductOption,
  setPriceBranchOptions,
  setPriceBranch,
  setEditProductId,
  setSelectMultiTags,
  clearSearchListCache,
} from 'slices/product/form/reducer';
import { FormikProps } from 'formik';
import {
  GetProductByIdFromAPI,
  ProductFormDetailsInterface,
} from 'types/productTypes';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import AlertWrapper from './AlertWrapper';
import {
  convertToProductCategoryOptions,
  convertToSupplierOptions,
} from 'utils/products/converter';
import { validationSchema } from './ValidationSchema';
import ProductForm from './ProductForm';
import { RootState } from 'slices';
import { useTranslation } from 'react-i18next';
import {
  getProductById,
  getSearchProductsCategory,
  getSearchSuppliers,
  postAddProduct,
  putUpdateProduct,
} from 'services/productService';
import { transformProductDataFromAPI } from 'utils/mappers/productMapper';
import { getImageNameFromUrl } from 'utils/imageManipulation';
import { getProductOptionList } from 'services/ProductOptionService';
import {
  transformPriceBranchToSelectOptions,
  transformProductOptionAPIToProductForm,
  updateProductOptions,
} from 'utils/productOption/converter';
import { ITEMS } from 'Routes/constants';
import { mapTagsInProductToSelectOptions } from 'utils/mappers/tagMapper';
import LoaderModal from 'Components/pos2u/Modals/LoaderModal';
import {
  setGetProductOption,
  setProcessError,
  setProcessLoading,
  setIsLoadProductOptionsSuccess,
} from 'slices/product/management/reducer';
import { setEditSession, setIsBack } from 'slices/editSession/reducer';
import SuccessModal from 'Components/pos2u/Modals/SuccessModal';
import Loader from 'Components/Common/Loader';
// import Loader from 'Components/Common/Loader';

const ProductsPage = () => {
  const { t, i18n } = useTranslation();
  const { id } = useParams();

  const addTitle = t('Add Product') + ' | POS2U';
  const editTitle = t('Edit Product') + ' | POS2U';
  document.title = id ? editTitle : addTitle;

  const dispatch: ThunkDispatch<RootState, void, Action> = useDispatch();

  const productFormState = useSelector((state: RootState) => state.Product);
  const {
    isEdit,
    editStoreId,
    editProductId,
    isDeleteImg,
    error,
    success,
    modalBackdrop,
    productFormDetails,
    pageConfig,
    imgNameFromAPI,
    productEditFormDetails,
    compositeModal,
  } = productFormState.form;

  const { GetProductOptions, isLoadProductOptionsSuccess } =
    productFormState.management.fetchProductOptions;

  const { processingStatus } = productFormState.management;

  const infoState = useSelector((state: RootState) => state.Info);
  const { merchant, isMerchantLoaded, branchCodes, isBranchesLoaded } =
    infoState;

  const initialValues = isEdit ? productEditFormDetails : productFormDetails;
  const formikRef = useRef<FormikProps<ProductFormDetailsInterface>>(null);
  const alertRef = useRef<HTMLDivElement | null>(null);

  const [isLoadSuccess, setIsLoadSuccess] = useState<boolean>(false);
  // const [groupPriceReady, setGroupPriceReady] = useState(false);

  // useEffect(() => {
  //   if (productFormDetails.pageConfig?.group_price) {
  //     setGroupPriceReady(true);
  //   }
  // }, [productFormDetails.pageConfig?.group_price]);
  // useEffect(() => {
  //   if (productFormDetails.pageConfig?.group_price !== undefined) {
  //     setGroupPriceReady(true);
  //   } else if (productEditFormDetails.pageConfig?.group_price !== undefined) {
  //     setGroupPriceReady(true);
  //   }
  // }, [
  //   productFormDetails.pageConfig?.group_price,
  //   productEditFormDetails.pageConfig?.group_price,
  // ]);

  //todo ===================== Retreive Data ===================== //
  // const fetchPageConfig = useCallback(async () => {
  //   try {
  //     const response = await getMerchant();
  //     if (response) {
  //       const { message, error_code, data } = response;

  //       if (message === 'OK' && error_code === 0) {
  //         const { group_price, custom_item_code, default_tax_1_rate } = data;
  //         dispatch(
  //           setPageConfig({ group_price, custom_item_code, default_tax_1_rate })
  //         );

  //         // dispatch(setPageConfig({ ...data, custom_item_code: false })); //! for testing
  //       }
  //     }

  //     console.log(response);
  //   } catch (error) {
  //     console.error('Failed to fetch product categories:', error);
  //   }
  // }, [dispatch]);

  const fetchProductCategories = useCallback(async () => {
    if (!merchant?.id) return;
    try {
      const response = await getSearchProductsCategory(`[${merchant.id}]`);

      if (response) {
        const { message, error_code, data } = response;

        if (message === 'OK' && error_code === 0) {
          const categoryOptions = data.categories
            ? await convertToProductCategoryOptions(data.categories)
            : [{ options: [] }];
          dispatch(setProductsCategoryOptions(categoryOptions));
        } else {
          dispatch(setProductsCategoryOptions([{ options: [] }]));
        }
      } else {
        console.error('No response data returned');

        dispatch(setProductsCategoryOptions([{ options: [] }]));
      }
    } catch (error) {
      console.error('Failed to fetch product categories:', error);
      dispatch(setProductsCategoryOptions([{ options: [] }]));
    }
  }, [dispatch, merchant]);

  const fetchSuppliers = useCallback(async () => {
    if (!merchant?.id) return;
    try {
      //! FIXME: This value is currently fixed for testing. Update this logic in the future.
      const response = await getSearchSuppliers(`[${merchant.id}]`);
      if (response) {
        const { message, error_code, data } = response;

        if (message === 'OK' && error_code === 0) {
          const supplierOptions = data.suppliers
            ? await convertToSupplierOptions(data.suppliers)
            : [{ options: [] }];
          dispatch(setSupplierOptions(supplierOptions));
        } else {
          dispatch(setSupplierOptions([{ options: [] }]));
        }
      } else {
        console.error('No response data returned');

        dispatch(setSupplierOptions([{ options: [] }]));
      }
    } catch (error) {
      console.error('Failed to fetch suppliers:', error);
      dispatch(setSupplierOptions([{ options: [] }]));
    }
  }, [dispatch, merchant]);

  const fetchOneProductByID = useCallback(
    async (id: string) => {
      // setFormReady(false);
      setIsLoadSuccess(false);
      if (!isBranchesLoaded) return;
      if (!branchCodes || branchCodes.length === 0) return;
      if (!id || id === '') return;
      if (!isLoadProductOptionsSuccess) return;
      dispatch(setEditProductId(parseInt(id, 10)));
      try {
        const response = await getProductById(id);
        // console.log(response);

        if (response) {
          const { message, error_code, data } = response;

          if (message === 'OK' && error_code === 0) {
            if (data) {
              const convertedProductData =
                await transformProductDataFromAPI(data);

              // console.log(`convertedProductData`);
              // console.log(convertedProductData.pricesByBranch);

              // console.log(`convertedProductData`);
              // console.log(convertedProductData);
              const newOptionState = updateProductOptions(
                GetProductOptions,
                convertedProductData.productOptions
              );
              const finalProductData = {
                ...convertedProductData,
                productOptions: newOptionState,
              };
              // console.log(`newOptionState`);
              // console.log(newOptionState);
              // dispatch(setEditProductOption(newOptionState));
              // dispatch(setGetProductOption(newOptionState));
              const priceBrachOptions = transformPriceBranchToSelectOptions(
                branchCodes,
                data.prices_by_branch
              );
              dispatch(setPriceBranch(data.prices_by_branch));
              dispatch(setPriceBranchOptions(priceBrachOptions));
              dispatch(setEditStoreId(data.store_id));
              dispatch(setProductEditFormDetails(finalProductData));
              dispatch(setImgDisplay(data.images.thumbs));
              if (data.images.thumbs) {
                dispatch(
                  setSelectedFiles([
                    {
                      preview: data.images.thumbs,
                      name: getImageNameFromUrl(data.images.thumbs),
                    },
                  ])
                );
              }

              const composites = data.composites;
              if (data.product_stock_type && data.product_stock_type === 1) {
                dispatch(setIsPieces(false));
                dispatch(setIsNoFragment(true));
                dispatch(setIsNoStock(true));
              } else {
                dispatch(setIsNoStock(false));
                if (data.unit_type && data.unit_type === 1) {
                  dispatch(setIsPieces(false));
                } else {
                  dispatch(setIsPieces(true));
                }
                if (composites && composites.length > 0) {
                  dispatch(setIsNoFragment(false));
                } else {
                  dispatch(setIsNoFragment(true));
                }
              }

              const transformedTags = mapTagsInProductToSelectOptions(
                data.tags ? data.tags : []
              );
              dispatch(setSelectMultiTags(transformedTags));
            }
            setIsLoadSuccess(true);
            return data;
          } else {
            if (message === 'Not found data') {
              dispatch(apiError({ message, error_code }));
            } else {
              dispatch(apiError({ message, error_code }));
            }
            setIsLoadSuccess(true);
            return {};
          }
        } else {
          console.error('No response data returned');
          setIsLoadSuccess(true);
          return {};
        }
      } catch (error) {
        console.log(error);
        setIsLoadSuccess(true);
        return {};
      }
    },
    [
      dispatch,
      GetProductOptions,
      branchCodes,
      isBranchesLoaded,
      isLoadProductOptionsSuccess,
    ]
  );

  const fetchProductOptionList = useCallback(async () => {
    if (isLoadProductOptionsSuccess) return;
    try {
      dispatch(setIsLoadProductOptionsSuccess(false));
      const response = await getProductOptionList();

      if (response) {
        const { message, error_code, data } = response;
        if (message === 'OK' && error_code === 0) {
          const { product_options } = data;

          const transformedData =
            transformProductOptionAPIToProductForm(product_options);
          dispatch(setProductOption(transformedData));
          dispatch(setGetProductOption(transformedData));
          dispatch(setIsLoadProductOptionsSuccess(true));
        } else {
          dispatch(setProductOption([]));
          dispatch(setGetProductOption([]));
          dispatch(setIsLoadProductOptionsSuccess(false));
        }
      } else {
        console.error('No response data returned');

        dispatch(setProductOption([]));
        dispatch(setGetProductOption([]));
        dispatch(setIsLoadProductOptionsSuccess(false));
      }
    } catch (error) {
      console.error('Failed to fetch product option data:', error);

      dispatch(setProductOption([]));
      dispatch(setGetProductOption([]));
      dispatch(setIsLoadProductOptionsSuccess(false));
    }
  }, [dispatch, isLoadProductOptionsSuccess]);
  useEffect(() => {
    fetchProductOptionList();
  }, [fetchProductOptionList]);

  useEffect(() => {
    if (isMerchantLoaded && merchant?.id) {
      fetchProductCategories();
    }
  }, [fetchProductCategories, isMerchantLoaded, merchant]);
  useEffect(() => {
    if (isMerchantLoaded && merchant?.id) {
      fetchSuppliers();
    }
  }, [fetchSuppliers, isMerchantLoaded, merchant]);

  //todo ===================== Retreive Data ===================== //

  useEffect(() => {
    if (formikRef.current) {
      formikRef.current.validateForm();
    }
  }, [i18n.language]);

  // useEffect(() => {
  //   fetchPageConfig();
  // }, [fetchPageConfig, isEdit]);
  // useEffect(() => {
  //   fetchPageConfig();
  // }, [i18n.language, fetchPageConfig]);

  useEffect(() => {
    if (
      id &&
      id !== '' &&
      isBranchesLoaded &&
      branchCodes.length > 0 &&
      isLoadProductOptionsSuccess
    ) {
      fetchOneProductByID(id);
      dispatch(setIsEdit(true));
    } else {
      dispatch(resetProduct());
    }
  }, [
    id,
    dispatch,
    fetchOneProductByID,
    branchCodes.length,
    isBranchesLoaded,
    isLoadProductOptionsSuccess,
  ]);

  // useEffect(() => {
  //   const loadProduct = async () => {
  //     if (id && id !== '') {
  //       dispatch(setIsEdit(true));
  //       await fetchOneProductByID(id);
  //     } else {
  //       dispatch(resetProduct());
  //     }
  //   };
  //   loadProduct();
  // }, [id, dispatch, fetchOneProductByID]);

  useEffect(() => {
    if (success !== '' || error !== '') {
      alertRef.current?.focus();
    }
  }, [success, error]);

  useEffect(() => {
    if (isEdit && productEditFormDetails && formikRef.current) {
      formikRef.current.setValues({
        ...productEditFormDetails,
        productName: productEditFormDetails.productName || '',
        productCode: productEditFormDetails.productCode || '',
        pageConfig: pageConfig,
        barcode: productEditFormDetails.barcode || '',
        category: productEditFormDetails.category || '',
        supplier: productEditFormDetails.supplier || '',
        productDetails: productEditFormDetails.productDetails || '',
        cost_price: productEditFormDetails.cost_price || {
          value: '',
          apply_all: 0,
        },
        unit_price: productEditFormDetails.unit_price || {
          value: '',
          apply_all: 0,
        },
        unit_price1: productEditFormDetails.unit_price1 || {
          value: '',
          apply_all: 0,
        },
        unit_price2: productEditFormDetails.unit_price2 || {
          value: '',
          apply_all: 0,
        },
        unit_price3: productEditFormDetails.unit_price3 || {
          value: '',
          apply_all: 0,
        },
        unit_price4: productEditFormDetails.unit_price4 || {
          value: '',
          apply_all: 0,
        },
        vat: productEditFormDetails.vat || '',
        product_stock_type: productEditFormDetails.product_stock_type || '0',
        unit_type: productEditFormDetails.unit_type || '0',
        inventory_type: productEditFormDetails.inventory_type || '1',
        first_page_pos: productEditFormDetails.first_page_pos || false,
        display_pos: productEditFormDetails.display_pos || false,
        composites: productEditFormDetails.composites || [],
        productOptions: productEditFormDetails.productOptions || [],
        pricesByBranch: productEditFormDetails.pricesByBranch || [],
        quantity_notify: productEditFormDetails.quantity_notify || '',
        tags: productEditFormDetails.tags || [],
      });
    } else if (!isEdit && productFormDetails && formikRef.current) {
      formikRef.current.setValues({
        ...productFormDetails,
        vat: String(pageConfig.default_tax_1_rate) || productFormDetails.vat,
        productOptions: GetProductOptions,
        pageConfig: pageConfig,
      });
      // formikRef.current.setValues(productFormDetails);
    }
  }, [
    isEdit,
    productEditFormDetails,
    productFormDetails,
    GetProductOptions,
    pageConfig,
  ]);

  //todo ===================== Modal ============================ //
  const searchInputRef = useRef<HTMLInputElement>(null);
  //todo ===================== Modal ============================ //

  useEffect(() => {
    if (compositeModal.isModalOpen) {
      setTimeout(() => {
        searchInputRef.current?.focus();
      }, 100);
    }
  }, [compositeModal.isModalOpen]);

  //todo ===================== Modal ============================ //
  const toggleModal = useCallback(
    (index: number | null = null) => {
      dispatch(setModalOpen(!compositeModal.isModalOpen));
      dispatch(setActiveInputIndex(index));
    },
    [compositeModal.isModalOpen, dispatch]
  );

  const closeModal = () => toggleModal(null);

  const selectProduct = useCallback(
    (
      product: GetProductByIdFromAPI,
      formik: FormikProps<ProductFormDetailsInterface>
    ) => {
      if (compositeModal.activeInputIndex !== null) {
        formik.setFieldValue(
          `composites[${compositeModal.activeInputIndex}].name`,
          product.name
        );
        formik.setFieldTouched(
          `composites[${compositeModal.activeInputIndex}].name`,
          true
        );
        formik.setFieldValue(
          `composites[${compositeModal.activeInputIndex}].item_id_number`,
          product.item_id_number
        );
        formik.setFieldTouched(
          `composites[${compositeModal.activeInputIndex}].item_id_number`,
          true
        );
        toggleModal(null);
      }
    },
    [compositeModal.activeInputIndex, toggleModal]
  );

  //todo ===================== Modal ============================ //

  const toggleModalBackDrop = useCallback(() => {
    dispatch(setModalBackdrop(!modalBackdrop));
  }, [dispatch, modalBackdrop]);

  const resetProductFormAfterSuccess = useCallback(() => {
    formikRef.current?.resetForm();
    dispatch(clearSearchListCache());
    dispatch(setModalBackdrop(false));
    dispatch(resetProduct());
  }, [dispatch]);

  const submitProductForm = async (values: ProductFormDetailsInterface) => {
    if (!merchant?.id) return;
    dispatch(apiError({ message: '' }));
    dispatch(setProcessError(''));
    dispatch(setProcessLoading(true));
    try {
      if (isEdit === true && id && id !== '' && editProductId) {
        if (editStoreId === null) return;
        //? ================ Update Existing Product ================ //

        const response = await putUpdateProduct(
          editStoreId,
          editProductId.toString(),
          values,
          imgNameFromAPI,
          isDeleteImg
        );

        if (response) {
          const { message, error_code, data } = response;

          if (message === 'OK' && error_code === 0) {
            // fetchPageConfig();
            if (data) {
              const convertedProductData =
                await transformProductDataFromAPI(data);
              const baseProductOptions =
                formikRef.current?.values.productOptions?.length
                  ? formikRef.current.values.productOptions
                  : productEditFormDetails.productOptions?.length
                    ? productEditFormDetails.productOptions
                    : productFormDetails.productOptions?.length
                      ? productFormDetails.productOptions
                      : GetProductOptions;

              const newOptionState = updateProductOptions(
                baseProductOptions,
                convertedProductData.productOptions
              );

              const finalProductData = {
                ...convertedProductData,
                productOptions: newOptionState,
              };
              dispatch(setProductEditFormDetails(finalProductData));
              if (formikRef.current) {
                formikRef.current.setValues({
                  ...formikRef.current.values,
                  ...finalProductData,
                });
              }
              dispatch(setImgDisplay(data.images.thumbs));
              if (data.images.thumbs) {
                dispatch(
                  setSelectedFiles([
                    {
                      preview: data.images.thumbs,
                      name: getImageNameFromUrl(data.images.thumbs),
                    },
                  ])
                );
              }

              const composites = data.composites;
              if (data.product_stock_type && data.product_stock_type === 1) {
                dispatch(setIsPieces(false));
                dispatch(setIsNoFragment(true));
                dispatch(setIsNoStock(true));
              } else {
                dispatch(setIsNoStock(false));
                if (data.unit_type && data.unit_type === 1) {
                  dispatch(setIsPieces(false));
                } else {
                  dispatch(setIsPieces(true));
                }
                if (composites && composites.length > 0) {
                  dispatch(setIsNoFragment(false));
                } else {
                  dispatch(setIsNoFragment(true));
                }
              }
            }

            dispatch(apiSuccess({ message, data }));
            dispatch(clearSearchListCache());
          } else {
            dispatch(apiError({ message, error_code }));
            dispatch(setProcessError(message));
          }
        } else {
          console.error('No response data returned');
          dispatch(apiError({ message: 'No response data returned' }));
          dispatch(setProcessError('No response data returned'));
        }
      } else {
        // dispatch(addProduct(values, imgNameFromAPI, fetchPageConfig, history));
        //? ================ Add New Product ================ //

        const response = await postAddProduct(
          merchant.id,
          values,
          imgNameFromAPI
        );

        if (response) {
          const { message, error_code, data } = response;

          if (message === 'OK' && error_code === 0) {
            dispatch(apiSuccess({ message, data }));
            dispatch(clearSearchListCache());
          } else {
            dispatch(apiError({ message, error_code }));
            dispatch(setProcessError(message));
          }
        } else {
          console.error('No response data returned');
          dispatch(apiError({ message: 'No response data returned' }));
          dispatch(setProcessError('No response data returned'));
        }
      }
      dispatch(setProcessLoading(false));
    } catch (error) {
      const optTxt = id ? 'updating' : 'adding';
      const errorTxt = `Error ${optTxt} product`;
      console.error(`${errorTxt} details:`, error);
      dispatch(apiError({ message: errorTxt }));
      dispatch(setProcessError('No response data returned'));
      dispatch(setProcessLoading(false));
    }
  };

  return (
    <React.Fragment>
      <div className={`page-content ${styles['product-text']}`}>
        {/* {groupPriceReady ? ( */}
        <Container fluid>
          {error !== '' && (
            <div
              ref={alertRef}
              tabIndex={-1}
              aria-live="assertive"
              className="mb-3"
            >
              <AlertWrapper
                type="error"
                message={t(error)}
                heading={t('something_went_wrong')}
              />

              {/* <AlertWrapper
                type="success"
                message={success}
                heading={`Product successfully ${textStatus} 🥳`}
              /> */}
            </div>
          )}
          {/* <ModalBackdrop
            id={id ? id : null}
            dispatch={dispatch}
            toggleModalBackDrop={toggleModalBackDrop}
          /> */}
          <SuccessModal
            isOpen={modalBackdrop}
            onClose={toggleModalBackDrop}
            goBackTo={ITEMS.LIST}
            addAnotherTo={ITEMS.ADD}
            goBackLabel={t('Btn_GoBackToItems')}
            addAnotherLabel={t('Btn_Add_Another')}
            onGoBack={() => {
              dispatch(setModalBackdrop(false));
              dispatch(setEditSession(id ?? null));
              dispatch(setIsBack(true));
              dispatch(resetProduct());
            }}
            onAddAnother={() => {
              resetProductFormAfterSuccess();
            }}
          />
          <BreadCrumb
            title={id ? t('Edit Product') : t('Add Product')}
            pageTitle={t('Items')}
            link={ITEMS.LIST}
          />
          {isLoadSuccess || !isEdit ? (
            <ProductForm
              dispatch={dispatch}
              initialValues={initialValues}
              validationSchema={validationSchema(t)}
              submitProductForm={submitProductForm}
              formikRef={formikRef}
              selectProduct={selectProduct}
              searchInputRef={searchInputRef}
              toggleModal={toggleModal}
              closeModal={closeModal}
            />
          ) : (
            <Loader />
          )}
        </Container>
        {/* ) : (
          <Loader />
        )} */}
        <LoaderModal
          isOpen={processingStatus.loading}
          error={processingStatus.error}
          onClose={() => dispatch(setProcessLoading(false))}
        />
      </div>
    </React.Fragment>
  );
};

export default ProductsPage;
